import { FeatureAlert } from "../../context/ultimateAlertsContext"
import useStrings from "../../localization/useStrings"

export type FeatureType = "ultimate" | "premium" | "free"

export interface ComparePlansFeature {
  name: string
  type: FeatureType
  alert?: FeatureAlert
  premiumText?: string
  ultimateText?: string
}

export function useComparePlansFeatures() {
  const strings = useStrings()

  const features: ComparePlansFeature[] = [
    {
      name: "Cloud Vault",
      type: "premium",
      premiumText: "50 GB",
      ultimateText: "1,000 GB",
    },
    {
      name: strings.features.organizationPlus,
      type: "ultimate",
      alert: "organization+",
    },
    {
      name: strings.features.securityPlus,
      type: "ultimate",
      alert: "security+",
    },
    { name: strings.features.duplicateDetection, type: "ultimate" },
    { name: strings.trashRecovery, type: "premium" },
    { name: strings.adFree, type: "premium" },
    { name: strings.breakIn, type: "premium" },
    { name: strings.features.faceDownLock, type: "premium" },
    { name: strings.wireless, type: "premium" },
    { name: strings.decoy, type: "premium" },
    { name: strings.pattern, type: "premium" },
    { name: strings.features.customIcons, type: "premium" },
    { name: strings.features.encryptedStorage, type: "free" },
    { name: strings.features.unlimitedAlbums, type: "free" },
    { name: strings.features.browser, type: "free" },
    { name: strings.features.camera, type: "free" },
  ]

  return features
}
